import Vue from "vue";
import * as HtmlEntities from "html-entities";

const entities = new HtmlEntities.XmlEntities();
const VDecode = {
    bind: function (el, binding, vnode) {
        VDecode.update(el, binding, vnode);
    },
    update: function (el, binding, vnode) {
        if(binding.value != binding.oldValue) {
            el.innerText = entities.decode(binding.value);
        }
    }
}
Vue.directive('decode', VDecode);

export default {
    d(html) {
        return entities.decode(html);
    }
}